<div class="schedule-legend-item">
  <mat-icon [svgIcon]="icon"></mat-icon>
</div>
{{label}}
